import React from 'react';
import useStyles from './styles';
import { FormControl, Input } from '@material-ui/core';
import clsx from 'clsx';
import { getIconLearningContent } from '../../../utils/helpers/icon/iconHelper'

const InputSecretCode = (props) => {
    const { secretCode, onChange, onClick, placeholder, onKeyDown, takeAssement } =  props
    const classes = useStyles()

    return (
        <div className={clsx(classes.wrapper)}>
            <FormControl
                className={clsx(classes.containerInput)}>
                <Input
                    classes={{ input: classes.input }}
                    placeholder={placeholder}
                    value={secretCode}
                    onChange={onChange}
                    disableUnderline={true}
                    onKeyDown={onKeyDown}
                />
            </FormControl>
            {takeAssement &&
                <div className={clsx(classes.containerIcon)} onClick={onClick}>
                    <img src={getIconLearningContent().ic_submit_code} />
                </div>
            }
        </div>
    )
}

export default InputSecretCode;